<div class="filter-container">
  <div class="search-box">
    <select [formControl]="searchType">
      <option value="1">BUSCA POR CNPJ</option>
      <option value="2">BUSCA POR RAZÃO SOCIAL</option>
    </select>
    <input
      #inputValue
      *ngIf="searchType.value == 1"
      [(ngModel)]="filterText"
      placeholder="01.234.567/0001-00"
      [textMask]="{
        mask: fiscalNumberMask,
        guide: false,
        keepCharPositions: true
      }"
      (keypress)="onPressEnterSearchCompanies($event)" />
    <input #inputValue *ngIf="searchType.value == 2" [(ngModel)]="filterText" placeholder="Razão Social" (keypress)="onPressEnterSearchCompanies($event)" />
    <div class="search-icon-container" (click)="searchIndustries()">
      <mat-icon aria-hidden="false">search</mat-icon>
    </div>
  </div>
</div>
<div *ngIf="hasResult()" class="quantities-container">
  <p class="result-quantity">{{ getResultQuantity() }}</p>
</div>
<div *ngIf="hasResult()" class="industry-list-container">
  <div *ngFor="let industry of getIndustries()" class="industry-card">
    <div class="industry-logo">
      <img src="./assets/icons/no-logo-company-icon.svg" />
    </div>
    <div class="industry-data">
      <div class="industry-card-header">
        <span class="industry-name" [matTooltip]="industry.getCompany().getTradingName()">{{ industry.getCompany().getTradingName() }}</span>
      </div>

      <div class="industry-data-container">
        <div class="data-container">
          <span class="data-value"><strong>Data: </strong>{{ industry.getCreated() }}</span>
        </div>
        <div class="data-container">
          <span class="data-value"><strong>Produtos: </strong>{{ industry.getProductCount() }}</span>
        </div>
        <div class="data-container">
          <span class="data-value"><strong>CNPJ: </strong>{{ industry.getCompany().getFiscalNumber() | companyFederalNumber }}</span>
        </div>
        <div class="data-container">
          <span class="data-value" [matTooltip]="industry.getCompany().getCorporateName()"
            ><strong>Razão Social: </strong>{{ industry.getCompany().getCorporateName() }}</span
          >
        </div>
      </div>
    </div>
    <div class="industry-status">
      <button mat-flat-button class="edit-btn" (click)="navigateToEdit(industry.getIndustryDiscountKey().getValue())">
        <mat-icon aria-hidden="false">edit_note</mat-icon>
        <span>EDITAR</span>
      </button>
    </div>
  </div>
  <a class="more-registers-btn" *ngIf="hasMoreIndustriesToSearch()">carregar mais registros</a>
</div>

<div *ngIf="!hasIndustries()" class="no-results">
  <p>Não foram encontrados resultados.</p>
</div>
